export enum TaskState {
  pending = 'pending',
  inProgress = 'inProgress',
  completed = 'completed',
}
